export default "__VITE_ASSET__HU2YT8qH__"